import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useGetBreakpoints } from "../../../hooks/useGetBreakpoints";
import { fetchStart, fetchSuccess } from "../../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../../util/Api";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Slider from "react-slick";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import offerPromo from "../../../assets/images/offerPromo.svg";
import lineDesign from "../../../assets/images/line-design.svg";
import promoimg from "../../../assets/images/promo.svg";

const AdminPromotions = () => {
  const dispatch = useDispatch();
  const [Promotions, setPromotions] = useState([]);
  const { isMobile } = useGetBreakpoints();

  useEffect(() => {
    fetchPromotions();
  }, [dispatch]);

  const fetchPromotions = async () => {
    try {
      dispatch(fetchStart());
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/broadcastpromotions/offers?page=1&limit=100`
      );
      const broadcastPromotions = response.data.data.rows;
      setPromotions(broadcastPromotions);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    } finally {
      dispatch(fetchSuccess());
    }
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow custom-prev-arrow" onClick={onClick}>
        <LeftOutlined style={{ color: "#FFFFFF" }} />
      </div>
    );
  };

  const NextArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow custom-next-arrow" onClick={onClick}>
        <RightOutlined style={{ color: "#FFFFFF" }} />
      </div>
    );
  };
  const settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  const filteredPromotion = Promotions.filter(
    (promotion) => promotion.bannerType === "type_1"
  );

  return filteredPromotion && filteredPromotion.length > 0 ? (
    <div>
      <Slider {...settings}>
        {filteredPromotion.map((promotion) => (
          <div
            key={promotion.id}
            className={
              isMobile ? "mobile-promotion-banner" : "promotion-banner"
            }
          >
            <div className={isMobile ? "mobile-banner-image" : "banner-image"}>
              <img src={promoimg} alt="promo-img" />
              <img
                src={lineDesign}
                alt="watermark"
                className="watermark"
                style={{
                  opacity: 0.1,
                  position: "absolute",
                  top: "10%",
                  left: "10%",
                  transform: "translate(-50%, -50%)",
                  zIndex: -1,
                  width: "40%",
                  height: "300%",
                }}
              />
            </div>

            <div>
              <h2 className={isMobile ? "mobile-banner-title" : "banner-title"}>
                {promotion.title}
              </h2>
              <p className={isMobile ? "mobile-banner-desc" : "banner-desc"}>
                {promotion.description}
              </p>
              {promotion.urlType === "internal_url" ? (
                <Link to={`${promotion.url}`}>
                  <Button
                    className={isMobile ? "mobile-avail-now" : "avail-now"}
                  >
                    Go
                  </Button>
                </Link>
              ) : (
                <a
                  href={promotion.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    className={isMobile ? "mobile-avail-now" : "avail-now"}
                  >
                    Go
                  </Button>
                </a>
              )}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  ) : null;
};

export default AdminPromotions;
